import { useEffect, useState } from "react";
import { api } from "./api";
import { getInitData, getStartParam, haptic, initTelegram } from "./telegram";
import { navigate, useRoute } from "./router";
import { HomePage } from "./pages/Home";
import { LobbyPage } from "./pages/Lobby";
import { GamePage } from "./pages/Game";
import { ProfilePage } from "./pages/Profile";
import { LeaderboardPage } from "./pages/Leaderboard";
import { HistoryPage } from "./pages/History";

export function App() {
  const route = useRoute();
  const [ready, setReady] = useState(false);
  const [authError, setAuthError] = useState<string | null>(null);

  useEffect(() => {
    initTelegram();
    if (!getInitData()) {
      setAuthError("این Mini App باید داخل تلگرام باز شود.");
      return;
    }
    api
      .auth()
      .then(() => {
        setReady(true);
        const startParam = getStartParam();
        if (startParam) {
          navigate("lobby", { room: startParam });
        }
      })
      .catch((e: Error) => setAuthError(e.message));
  }, []);

  if (authError) {
    return (
      <div className="screen center">
        <div className="card">
          <h2>⚠️ خطا</h2>
          <p>{authError}</p>
        </div>
      </div>
    );
  }
  if (!ready) {
    return (
      <div className="screen center">
        <div className="spinner" />
        <p>در حال اتصال…</p>
      </div>
    );
  }

  switch (route.page) {
    case "lobby":
      return <LobbyPage roomCode={route.params.get("room") ?? ""} />;
    case "game":
      return <GamePage roomCode={route.params.get("room") ?? ""} />;
    case "profile":
      return <ProfilePage />;
    case "leaderboard":
      return <LeaderboardPage />;
    case "history":
      return <HistoryPage />;
    default:
      return <HomePage />;
  }
}

export function useHaptic() {
  return haptic;
}
